import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyles'
import { useNavigate } from 'react-router-dom'

import { deleteSessions } from '../../../app/services/sessions/deleteSession'
import { useDispatch } from 'react-redux'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../redux/actions/app'
import { logEvent } from '../../../utils/LogEvents'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 225,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const DeleteSession = ({
  openModal,
  handleClose,
  uuidDeviceSessions = []
}) => {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const deleteSession = async (uuidSession) => {
    try {
      await deleteSessions(uuidSession)
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Sesión eliminada'))
    } catch (error) {
      logEvent('CGI - revokeSessionDeviceEAuth Failure', {
        uuidSession
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar('No se pudo eliminar la sesión'))
    }
  }

  const handledeleteSessions = async () => {
    setShowCircularProgress(true)
    if (!uuidDeviceSessions) return console.log('error')
    if (uuidDeviceSessions.length === 0) return console.log('ids null')
    for (let index = 0; index < uuidDeviceSessions.length; index++) {
      const uuidSession = uuidDeviceSessions[index]
      await deleteSession(uuidSession)
    }
    logEvent('CGI - revokeSessionDeviceEAuth', {
      uuidDeviceSessions
    })
    setTimeout(() => {
      navigate(0)
    }, 1000)
    setShowCircularProgress(false)
  }

  return (
    <>
      <Modal open={openModal} onClose={handleClose}>
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={handleClose}
            />
          </div>

          <div>
            <Typography sx={{ color: '#263057', fontSize: '1.3em' }}>
              Eliminar {uuidDeviceSessions.length > 1 ? 'todas las sesiones' : 'la sesión'}
            </Typography>
          </div>
          <Typography
            sx={{
              color: '#263057',
              fontFamily: 'Roboto',
              marginTop: '5%'
            }}
          >
            ¿Esta seguro de que desea eliminar {uuidDeviceSessions.length > 1 ? 'todas las sesiones' : 'la sesión'}?
          </Typography>

          <Box className={classes.buttons} style={{ marginLeft: '45%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              handledeleteSessions={handledeleteSessions}
            />

            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm ({ showCircularProgress, handledeleteSessions }) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = () => {
    if (!isProgressComplete && !showCircularProgress) {
      handledeleteSessions()
      setProgressComplete(true)
    }
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ''
        }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress
          ? (
          <CircularProgress size="1.5rem" color="inherit" />
            )
          : (
          <Typography className={classes.confirmButtonTypography}>
            Eliminar
          </Typography>
            )}
      </button>
    </div>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
